/**
 * HonestStat (spec §6) — every area-market number is a floor with its basis
 * printed under it, in muted type. No bare numbers anywhere on this page:
 * "47 active listings that we hold", "Median 96 days since we first saw
 * them", "12 verified sales, last 730 days".
 */

import type { ReactNode } from 'react'
import { Numeric } from '@/components/ui/numeric'

interface HonestStatProps {
  label: string
  /** The floor value — always rendered with a basis beneath it. */
  value: ReactNode
  /** The provenance sentence, muted. Never omit: a bare number is a lie here. */
  basis: string
  testId?: string
}

export function HonestStat({ label, value, basis, testId }: HonestStatProps) {
  return (
    <div data-testid={testId} className="flex flex-col gap-[var(--lc-space-2xs)]">
      <span className="text-[length:var(--lc-type-caption)] uppercase tracking-[var(--lc-tracking-overline)] text-[var(--lc-text-muted)]">
        {label}
      </span>
      <Numeric as="strong" className="text-[length:var(--lc-type-heading-3)] text-[var(--lc-text-heading)]">
        {value}
      </Numeric>
      <span className="text-[length:var(--lc-type-body-sm)] text-[var(--lc-text-muted)]">{basis}</span>
    </div>
  )
}
